import { SwitchDropdown } from '@/components/uiKit/Dropdown/SwitchDropdown';
import { Settings2, Layers } from 'lucide-react';
import React from 'react';
import { toLabel } from '../../Alarms/AlarmsFilters';
import { DataLayer } from '@/modules/AssetsStudioPage/SensorFusion/types';

interface SenorDataRightPaneMenuProps {
  opeartionalModes: any;
  activeOperationalModes: string[];
  activeDataLayers: string[];
  sensorFusionDataLayers: DataLayer[];
  setActiveOperationalModes: React.Dispatch<React.SetStateAction<string[]>>;
  setActiveDataLayers: React.Dispatch<React.SetStateAction<string[]>>;
  hideDataLayersDropdown?: boolean;
}

export function SenorDataRightPaneMenu({
  opeartionalModes,
  activeOperationalModes,
  sensorFusionDataLayers,
  activeDataLayers,
  setActiveOperationalModes,
  setActiveDataLayers,
  hideDataLayersDropdown = false,
}: SenorDataRightPaneMenuProps) {
  return (
    <div className="flex items-center justify-end w-full pr-2">
      {opeartionalModes.enabled && (
        <SwitchDropdown
          requireSelection={false}
          placementAlign="end"
          triggerVariant="ghost"
          triggerClassName="py-0"
          groups={[
            {
              title: ' ',
              requireSelection: true,
              options: opeartionalModes.options.map((option: any) => ({
                id: option.id,
                label: option.label,
                checked: activeOperationalModes.includes(option.id),
              })),
            },
          ]}
          triggerText={
            <span className="flex items-center text-sm font-semibold gap-2">
              <Settings2 size={16} />
              Operational Modes
            </span>
          }
          onSelectionChange={(selectedGroups) => {
            const selected = Object.values(selectedGroups)
              .flat()
              .map((el) => el.id);
            setActiveOperationalModes(selected);
          }}
        />
      )}
      {!hideDataLayersDropdown && (
        <SwitchDropdown
        requireSelection={true}
        placementAlign="end"
        triggerVariant="ghost"
        triggerClassName="py-0"
        groups={[
          {
            title: ' ',
            requireSelection: true,
            options: sensorFusionDataLayers.map((key) => ({
              id: key.id,
              label: toLabel(key.id),
              checked: activeDataLayers.includes(key.id),
            })),
          },
        ]}
        triggerText={
          <span className="flex items-center text-sm font-semibold gap-2">
            <Layers size={16} />
            Data Layers
          </span>
        }
        onSelectionChange={(selectedGroups) => {
          setActiveDataLayers(
            Object.values(selectedGroups)
              .flat()
              .map((el) => el.id)
          );
        }}
      />
      )}
    </div>
  );
}
